export default __webpack_public_path__ + "static/icon-medical-records-dde8694bc9a218becd1dc3050f1581b0.svg";